import clsx from 'clsx'
import React from 'react'

import { ChipOptions } from '@Domains/Product/Features/Display/ChipAssets'
import { ProductChips } from '@Domains/Product/Features/ProductChips/ProductChips'

import styles from './ProductChipsLayout.module.scss'

interface Props {
  className?: string
  freeDeliveryOverride?: boolean
  hideFreeDelivery?: boolean
  maxNumberOfTags?: number
  options: ChipOptions
}

const ProductChipsLayout = ({
  className,
  freeDeliveryOverride,
  hideFreeDelivery,
  maxNumberOfTags = 3,
  options,
}: Props) => {
  const {
    buyXPayForY,
    clubValue,
    enableDiscount,
    freeDelivery,
    isBestSeller,
    isNew,
    isPopularGift,
    personalizationTypes,
    price,
    showChips,
  } = options
  const discount = {
    percentage: price?.discount?.percent || 0,
    context: price?.discount?.code?.context || '',
  }

  if (!showChips) {
    return null
  }

  return (
    <ProductChips
      buyXPayForY={buyXPayForY}
      className={clsx(styles.productChips, className)}
      clubValue={clubValue}
      discount={enableDiscount && price?.discount ? discount : undefined}
      isBestSeller={isBestSeller}
      isFreeDelivery={hideFreeDelivery ? undefined : freeDelivery || freeDeliveryOverride}
      isNew={isNew}
      isPopularGift={isPopularGift}
      maxNumberOfChips={maxNumberOfTags}
      personalizationTypes={personalizationTypes}
    />
  )
}

export default ProductChipsLayout
